/* eslint-disable */
define('data/intent', [
    'jquery',
    'log',
    'common/util',
    'widget/dialog/success',
    'data/wechat-entry',
    'jquery.cookie',
    'jquery.fullscreen',
], ($, log, util) => {
    let successFun;
    let option;
    let type;

    let timer_phone_valid_tel_code = null;
    let timer_phone_valid_code_sending = false; // 是否正在请求中,在刷新图片时防止多次点击
    // 预约线索类型
    const APPOINT_TYPES = [
        'appointment',
        'consult',
        'discount_notify',
        'time_limit_appointment',
    ];

    // 所有 C2 线索类型
    const C2_TYPES = [
        'buyer',
        'bargain',
        'lxb',
        'appointment_edit',
        ...APPOINT_TYPES,
        ...APPOINT_TYPES.map(t => `${t}_extra`),
    ];

    const isAppointmentAction = action => APPOINT_TYPES.indexOf(action) !== -1; // 判断是否预约线索
    const isC2Action = action => C2_TYPES.indexOf(action) !== -1;               // 判断是否 C2 线索

    const optionFun = (data, done, qrcode, action) => { // eslint-disable-line
        successFun = done;
        const opt = {
            dataType: 'json',
            type: 'POST',
            url: `/index.php?d=api&c=intent&m=${action}`,
            // 设置超时为 30s
            timeout: 30000,
            error() {
                log.push(['_trackEvent', `pc_intent_${type}_timeout`, 'click', 'timeout']);
            },
            /* istanbul ignore next */
            success(jsonParam,textStatus,jqXHR,postData = this.data) { // eslint-disable-line
                const json = jsonParam;
                const verificationModalMarkup = $('#js-verification-modal-markup');
                if (verificationModalMarkup.length) {
                    $('body').append(verificationModalMarkup.html());
                    verificationModalMarkup.remove();
                }
                const ndVerificationModal = $('#js-verification-modal');
                const ndImage = $('#js-verification-img');
                const ndCode = $('#js-verification-code');
                const ndError = $('#js-verification-error');
                const ndSubmit = $('#js-verification-submit');
                ndVerificationModal.find('.js-delayed-img').each(function () {
                    const ndImg = $(this);
                    ndImg.attr('src', ndImg.attr('data-src')).removeClass('js-delayed-img');
                });
                ndSubmit.off('click');
                ndSubmit.on('click', () => {
                    if (ndCode.val() === '') {
                        ndError.show();
                        ndCode.focus();
                        return;
                    }
                    ndError.hide();
                    ndSubmit.attr('disabled', true);
                    option.data.verify_code = ndCode.val();
                    option.data.isRefresh = '';
                    $.ajax(option);
                });

                // 数据不合法
                if (!json || typeof json.status === 'undefined') {
                    return;
                }

                const status = parseInt(json.status, 10);
                const statusV2 = json.status_v2 ? parseInt(json.status_v2, 10) : 0;

                if (json.image) {
                    json.image = json.image.replace(/^http:/, '');
                }

                ndSubmit.attr('disabled', false);

                // 验证码
                /* instanbul ignore if 功能性测试覆盖到了这里的逻辑，暂时不写单测 */
                if (status === 400) {
                    // 隐藏短信验证码弹窗(触发验证码后提交的线索返回400)
                    setDisabledSubmitBtn(false);
                    $('#js-verification-box-code').fullscreen('hide');

                    const varlidateErrMsg = statusV2 === 429 ? '验证码输入失败次数过多，请等待' : '验证码不正确';
                    successFun(json);

                    ndCode.val('');
                    ndImage.attr('src', json.image);
                    // ndVerificationModal.fullscreen('show');
                    ndVerificationModal.fullscreen({
                        backdrop: 'static',
                        show: true,
                    });
                    ndVerificationModal.find('.dialog-title').html('请输入验证码');

                    ndCode.focus();

                    if (json.forced_message) {
                        ndError.html(varlidateErrMsg).show();
                    }

                    log.push(['_trackEvent', 'm_verification_show', 'click', 'verification']);
                    return;
                }

                // 隐藏图形验证码
                const $parseQueryString = util.parseQueryString(postData);
                if (ndVerificationModal.css('display') !== 'none') {
                    ndVerificationModal.fullscreen('hide');
                }

                // 展示短信验证码
                if(status === 1000){
                    $('#js-verification-tel-code').val('')// 清空之前填写的信息
                    getTelCodeFun(data, done, getSmscodeOptions, function(){
                        var vcode = $.trim($('#js-verification-tel-code').val());
                        if (!vcode) {
                            setErrorTxt('请输入手机验证码');
                            return false;
                        }
                        setErrorTxt('');
                        setDisabledSubmitBtn(true, '正在提交信息……');
                        data.verification_code = vcode;
                        $.ajax(opt)
                    })
                    return;
                }
                // 展示短信验证码
                if(status === 1001){
                    setErrorTxt('手机验证码有误')
                    setDisabledSubmitBtn(false);
                    return;
                }

                // 隐藏短信验证码弹窗
                setDisabledSubmitBtn(false);
                $('#js-verification-box-code').fullscreen('hide');

                // c2 补充
                if (json.display_next_page && intent.c2add($parseQueryString, json)) { // eslint-disable-line
                    return;
                }

                // 未登录用户，自动跳转至登录，仅限买车相关线索(触发短信验证逻辑后不再登录)
                /* instanbul ignore if 功能性测试覆盖到了这里的逻辑，暂时不写单测 */
                // if (!$parseQueryString.verification_code && !$.cookie('rrc_login_phone') && isC2Action(type)) {
                //     // // 单独处理砍价的逻辑
                //     // if (type === 'bargain') {
                //     //     $('#bargain_modal').fullscreen('hide');
                //     // }

                //     // 砍价和离线宝模块的数据格式不一样
                //     let mobileNumber;
                //     if (type === 'bargain' || type === 'lxb' || type === 'appointment_edit') {
                //         mobileNumber = data.phone;
                //     } else {
                //         mobileNumber = data.mobile_number;
                //     }

                //     window.location.href = `https://www.renrenche.com/login?source=${encodeURIComponent(window.location.href)}&phone=${mobileNumber}`;

                    // require(['react', 'react-dom', 'components/login'], (React, ReactDom, login) => {
                    //     // 通过登录模块

                    //     const ndLogin = document.getElementById('login');
                    //     if (!ndLogin) {
                    //         return;
                    //     }
                    //     const reactLogin = ReactDom.render(React.createElement(login.Login, {
                    //         onCallback() {
                    //             successFun(json);
                    //         },
                    //         RRC,
                    //     }), ndLogin);
                    //     reactLogin.setState({
                    //         title: '请输入短信验证码',
                    //         desc: '',
                    //         phone: mobileNumber,
                    //         disablePhone: true,
                    //         icon: '/dist/images/icon-code-30ec0fe8.png',
                    //         buttonText: '登录',
                    //         modalCls: `login-modal-${type}`,
                    //         isLoginShow: true,
                    //         showRules: false,
                    //     }, () => {
                    //         // 登录后自动发送验证码
                    //         reactLogin.getVerifyCode();
                    //     });
                    // });
                //     return;
                // }
                if (status === 0) {
                    log.push(['_trackEvent', `${$parseQueryString.submit_sources}-提交成功`, 'click', '']);
                }
                successFun(json);
            },
            data,
        };
        $.ajax(opt);
        return opt
    };

    const setErrorTxt = (errmsg = '') => {
        $('#js-verification-code-error').text(errmsg);
    };
    // 显示图片验证码输入框
    const showQRCodeBox = (image) => {
        setCodeTitle('imgcode'); // eslint-disable-line
        const imgDom = $('#js-verification-code-img');
        const inputImg = $('#js-verification-code-input');
        $('.verification-img-wrapper').show();
        imgDom.attr('src', image);
        inputImg.val('');
    };

    // 设置提交按钮禁用
    const setDisabledSubmitBtn = (stauts = true, txt = '提交') => {
        const submit = $('#js-verification-code-submit');
        submit.attr('disabled', stauts).text(txt);
    };
   // 验证码发送成功
    const successCallback = ({ status, image, error }) => {
        if (status === 0) {
            setDisabledSubmitBtn(false);
            $('.verification-img-wrapper').hide();
        } else if (status === 400) { // 触发图形验证码
            log.push(['_trackEvent', 'm_verification_show', 'click', 'verification']);
            setCodeTimerDom(false, '获取短信验证码')  // eslint-disable-line
            setDisabledSubmitBtn(true);
            showQRCodeBox(image); // eslint-disable-line
        }else if (status === 5100) { // 操作频繁
            $('#js-verification-tel-code').val('')// 清空之前填写的信息
            setCodeTimerDom(false, '获取短信验证码')
            setCodeTitle('smserr')
            setErrorTxt(error || '操作频繁，请稍后重试');
        } else {
            setErrorTxt(error || '未知错误，请稍后重试');
        }
    };

    // 设置页面发送验证码状态
    const setCodeTimerDom = (flag, txt = '获取短信验证码') => {
        const btn1 = $('.js-verification-tel-btn.gbtn');
        const btn2 = $('.js-verification-tel-btn.time');
        if (timer_phone_valid_tel_code) {
            window.clearInterval(timer_phone_valid_tel_code);
        }
        btn2.text('重新获取59秒');
        if (flag) {
            btn1.hide();
            btn2.show();
            setCodeTitle(); // eslint-disable-line
        } else {
            btn1.text(txt);
            btn1.show();
            btn2.hide();
        }
    };
    // 验证码弹窗 ajax options 拼接
    function getOptions(opt, code) {
        timer_phone_valid_code_sending = true;
        if (!opt.mobile_number.length) {
            return;
        }

        const { city, fr: channel, jwtsignature: __jwtsignature } = window.RRC;
        const data = Object.assign({
            city,
            channel,
            code,
            __jwtsignature
        }, opt);
        return {
            url: '/index.php?d=api&c=intent&m=order_sell_send',
            method: 'post',
            data,
            success: (res) => {
                timer_phone_valid_code_sending = false;
                successCallback(res);
            },
            error() {
                setErrorTxt('发送验证码失败，请稍后重试');
                timer_phone_valid_code_sending = false;
                setCodeTimerDom(false);
            }
        };
    }
    // 通用短信验证码接口, 接收参数phone
    function getSmscodeOptions(opt, code) {
        timer_phone_valid_code_sending = true;
        if (!opt.mobile_number.length) {
            return;
        }

        var _window$RRC = window.RRC,
            city = _window$RRC.city,
            channel = _window$RRC.fr,
            __jwtsignature = _window$RRC.jwtsignature;

        var data = Object.assign({
            city: city,
            channel: channel,
            code: code,
            __jwtsignature: __jwtsignature,
            typ: 1,
            phone: opt.mobile_number
        }, opt);
        return {
            url: '/api/user/getsmscode',
            method: 'post',
            data: data,
            success: function success(res) {
                timer_phone_valid_code_sending = false;
                successCallback(res);
            },
            error: function error() {
                setErrorTxt('发送验证码失败，请稍后重试');
                timer_phone_valid_code_sending = false;
                setCodeTimerDom(false);
            }
        };
    }
    // 设置弹窗title文字
    const setCodeTitle = (status = 'code') => {
        const tel = $('.form-wrapper-code-tel').data('tel');
        if (status === 'code') {  // 当前是输入短信验证码
            $('.form-wrapper-code-tel').text(`短信验证码已发送至${tel}`);
            $('.form-wrapper-code-title').text('请输入短信验证码');
        } else {    // 当前提示输入图片验证码
            $('.form-wrapper-code-tel').text(`短信验证码将发送至${tel}`);
            $('.form-wrapper-code-title').text('请输入验证码');
        }
    };
    // 设置发送验证码倒计时
    const setTelCodeTimer = () => {
        const status = $('.js-verification-tel-btn.time');
        let timers = 59;
        setCodeTimerDom(true);
        timer_phone_valid_tel_code = setInterval(function () {
            if (timers <= 0) {
                setCodeTimerDom(false);
                return;
            }
            status.text(`重新获取${timers}秒`);
            timers -= 1;
        }, 1000);
    };
    // 获取手机验证码
    const getTelCode = (data, btnType, optionFunc = getSmscodeOptions) => {
        $('#js-verification-tel-code').val('')// 清空之前填写的信息
        const codeDom = $('.verification-img-wrapper');
        let code = null;
        setErrorTxt();
        // 获取验证码时验证是否输入图形验证码
        if (codeDom.css('display') !== 'none' && btnType !== 'refresh') {
            code = $.trim($('#js-verification-code-input').val());
            if (code === '') {
                setErrorTxt('请输入图形验证码');
                return false;
            }
        }
        if (btnType !== 'refresh') {
            setTelCodeTimer();
        }
        $.ajax(optionFunc(data, code));
    };

    // 手机验证码-线索提交
    const submitCodeClues = (_data, done) => {
        const vcode = $.trim($('#js-verification-tel-code').val());
        if (!vcode) {
            setErrorTxt('请输入手机验证码');
            return false;
        }
        setErrorTxt('');
        setDisabledSubmitBtn(true, '正在提交信息……');
        const data = {
            vcode,
            city: _data.city,
            mobile_number: _data.mobile_number
        };
        data.vcode = vcode;
        const options = {
            url: '/index.php?d=api&c=intent&m=order_sell_check',
            method: 'post',
            // 设置超时为 30s
            timeout: 30000,
            data,
            success: (res) => {
                setDisabledSubmitBtn(false);
                if (res.status === 0) {
                    done(res);
                    $('#js-verification-box-code').fullscreen('hide');
                    log.push(['_trackEvent', `${data.submit_sources}-提交成功`, 'click', '']);
                } else {
                    setErrorTxt(res.errmsg || res.error || res.err_msg);
                }
            },
            error() {
                log.push(['_trackEvent', `pc_intent_${type}_timeout`, 'click', 'timeout']);
                setDisabledSubmitBtn(false);
                setErrorTxt('信息提交失败，请稍后重试');
            }
        };
        $.ajax(options);
    };
      // 获取短信验证码组件，传入获取验证码方法，提交线索方法
    var getTelCodeFun = function getTelCodeFun(data, done, _getTelCodeOption, _submitCodeClues) {
        var verificationCodeModal = $('#js-verification-modal-code');
        if (verificationCodeModal.length) {
            $('body').append(verificationCodeModal.html());
            verificationCodeModal.remove();
        }
        var ndVerificationModal = $('#js-verification-box-code');
        var verificationGetCode = $('.js-verification-tel-btn.gbtn');
        var verificationImgBox = $('.verification-img-wrapper');
        var verificationSubmit = $('#js-verification-code-submit');
        var refresh = $('#js-verification-code-refresh');
        ndVerificationModal.fullscreen({
            backdrop: 'static',
            show: true
        });

        $('.form-wrapper-code-tel').data('tel', data.mobile_number);
        verificationImgBox.hide();
        // 获取验证码
        verificationGetCode.off('click').on('click', function () {
            if (timer_phone_valid_code_sending) return false;
            getTelCode(data, '', _getTelCodeOption);
        });
        // 刷新图片验证码
        refresh.off('click').on('click', function () {
            if (timer_phone_valid_code_sending) return false;
            getTelCode(data, 'refresh', _getTelCodeOption); // eslint-disable-line
        });
        // 提交
        verificationSubmit.off('click').on('click', function () {
            _submitCodeClues(data, done);
        });
        setDisabledSubmitBtn(false);
        getTelCode(data, _getTelCodeOption);
    };

    /* istanbul ignore next */
    $('body').on('click', '#js-verification-modal .close-btn', function () {
        $(this).parents('#js-verification-modal').fullscreen('hide');
        $('#js-verification-error').html('').hide();
    });

    /* istanbul ignore next */
    $('body').on('click', '#js-verification-refresh', () => {
        option.data.isRefresh = 'true';
        $.ajax(option);
    });

    const intent = (action, dataParam, success, qrcode) => {
        const data = dataParam;
        type = action;
        const done = success || (() => undefined);

        if (isAppointmentAction(type)) {
            data.city = RRC.cityName;
        }
        data.device = 'pc';
        if (action === 'pc_order_sell') {
            getTelCodeFun(data, done, getOptions, submitCodeClues);
        } else {
            option = optionFun(data, done, qrcode, action);
        }
        if (RRC.pageLoadTime) {
            log.push(['_trackEvent', 'intent_first_submit_time', {
                time: (new Date()).getTime() - RRC.pageLoadTime,
                intent: action,
                submit_sources: data.submit_sources,
                platform: 'PC',
                pageName: RRC.pageName,
            }]);
            RRC.pageLoadTime = null;
        }
    };
    intent.c2add = (data, json) => {
        const c2action = {
            bargain: '砍价成功立即帮您约车',
            discount_notify: '降价后立即帮您约车',
            time_limit_appointment: '约车速度更快',
            appointment: '约车速度更快',
            consult: '车况合适立即帮您约车',
        };

        const isSold = !!($('#sold_button').length); // 是否为下架车

        if (typeof (c2action[type]) !== 'undefined' && RRC.pageName.indexOf('car-detail') > -1 && !isSold) {
            require(['page/detail/c2-add'], (c2add) => {
                let mobileNumber;
                if (type === 'bargain') {
                    mobileNumber = data.phone;
                } else {
                    mobileNumber = data.mobile_number;
                }
                const opt = {
                    title: c2action[type],
                    phone: mobileNumber,
                    userPrice: data.price,
                    salePrice: RRC.carPrice,
                    submit_sources: data.submit_sources,
                    sub_product: type,
                    profile: json.profile,
                };
                c2add.init(opt);
            });
            return true;
        }
        return false;
    };
    // 获取提示语
    intent.getMessage = (now = new Date()) => {
        if (now.getHours() < 8 || now.getHours() > 21) {
            return '人人车小伙伴下班了，上班后会尽快联系您，请注意接听来电';
        }
        return '人人车客服将尽快联系您，请保持手机畅通';
    };

    // export for test sake
    intent.isAppointmentAction = isAppointmentAction;
    intent.isC2Action = isC2Action;
    intent.optionFun = optionFun;

    return intent;
});
